<template>
    <v-snackbar v-model="snackbar.alert" :timeout="snackbar.timeout" dark>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="close_snackbar()" >
            {{ $i18n.t('general.close') }}
          </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  methods: {
    close_snackbar() {
      this.resetSnackbar();
    },
    ...mapActions(["resetSnackbar"])
  },
  computed: {
    ...mapGetters(["snackbar"])
  }
});
</script>

<style scoped>

</style>